import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './svgAndText.css'

interface IProps {
  img: string
  iconClassName?: string
  className: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export class SvgAndText extends React.Component<IProps> {

  render () {
    const s = classnames(styles.svgandtext, this.props.className)
    const iconClassName = classnames(styles.svgandtextIcon, this.props.iconClassName)
    let props = { ...this.props }
    delete props.img

    return (
      <div className={s} onClick={this.props.onClick}>
        <img className={iconClassName} src={this.props.img} />
        <div className={styles.svgandtextText}> {this.props.children} </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/elements/svgAndText.tsx